import { render, staticRenderFns } from "./DialogSalesInvoiceSend.vue?vue&type=template&id=dfdf5874"
import script from "./DialogSalesInvoiceSend.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSalesInvoiceSend.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports